import moment from 'moment';
// import 'moment/locale/vi';

const formatISOTimeToDateFrom = (timestamp) => {
  if (!timestamp) return 'Null';
  return moment(new Date(timestamp)).local().fromNow();
};

export default formatISOTimeToDateFrom;
